module.exports = __webpack_public_path__ + "ff376c21556646c233fb8254c315606e.pdf";